import { render, staticRenderFns } from "./opTable.vue?vue&type=template&id=49781600&"
import script from "./opTable.vue?vue&type=script&lang=ts&"
export * from "./opTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports